<script>
  import template from './template.html';
  import ClickOutside from 'vue-click-outside';

  export default {
    props: {
      userPrefs: {
        type: Object,
        default: function () {
          return {row_height: 'default'};
        }
      }
    },
      template,
    methods: {
      hideDensityDropdown () {
        this.toggles.densityDropdown = false;
      },

      changeRowDensity (size) {
        this.userPrefs.row_height = size;
        this.$emit('density', size);
      }
    },
    computed: {

      densityClass () {
        let densitySetting = "";

        switch (this.userPrefs.row_height) {
          case 'large':
            densitySetting = 'default';
            break;

          case 'medium':
            densitySetting = 'comfortable';
            break;

          case 'small':
            densitySetting = 'compact';
            break;

          default:
            densitySetting = 'default';
            break;
        }

        return `ai-density-${densitySetting}`;
      }
    },

    data () {
      return {
        toggles: {
          densityDropdown: false
        },
      }
    },

    directives: {
      ClickOutside
    },
  };
</script>
